import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';
import {QuickFilterModes} from '../../util/uiconstants';
import {FilterEntityConfiguration} from '../../components/Common/Filter/config';
import _ from 'lodash';

export default function bulkfilterdatareducer(state = initialstate.bulkFilterData, action) {
	switch (action.type) {
		case actions.GET_BULK_FILTER_ENTITIES:
			{
				if (action.response !== undefined) {
					const entityMapping = action.dataMapping || FilterEntityConfiguration[action.entityType]?.entityMapping;

					const data =
						entityMapping !== undefined && typeof entityMapping === 'function'
							? entityMapping(action.response)
							: action.response;

					return {
						...state,
						[action.key]: {
							...state[action.key],
							[action.name]: Utility.normalize(data, undefined, 'value')
						}
					};
				}
			}

			return state;
		case actions.UPDATE_BULK_FILTER_ENTITIES:
			if (action.key && action.entityKey) {
				let newState = _.cloneDeep(state);
				if (!_.isEmpty(newState) && Utility.hasValue(newState[action.key][action.entityKey])) {
					if (action.actionType === QuickFilterModes.add) {
						newState[action.key][action.entityKey]['byId'][action.childKey] = action.entityObj;
						newState[action.key][action.entityKey]['allIds'].push(action.childKey.toString());
					} else if (action.actionType === QuickFilterModes.edit){
						let existingObj = newState[action.key][action.entityKey]['byId'][action.childKey];
						existingObj.label = action.entityObj.label;
					} else {
						delete newState[action.key][action.entityKey]['byId'][action.childKey];
						newState[action.key][action.entityKey]['allIds']=newState[action.key][action.entityKey]['allIds'].filter(id => id != action.childKey.toString());
					}
					return newState;
				}

				return state;
			}

			return state;

		default:
			return state;
	}
}
